import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BannerHandlerService {
  constructor() {}

  verificarFecha(banner): boolean {
    let fin, inicio;
    const hoy = new Date();
    if (banner.fechaVencimiento !== null) {
      fin = new Date(banner.fechaVencimiento);
    } else {
      fin = null;
    }
    if (banner.fechaLanzamiento !== null) {
      inicio = new Date(banner.fechaLanzamiento);
    } else {
      inicio = null;
    }
    if (inicio !== null && fin !== null) {
      if (hoy >= inicio && hoy <= fin) {
        return true;
      } else {
        return false;
      }
    } else if (inicio !== null && fin === null) {
      if (hoy >= inicio) {
        return true;
      } else {
        return false;
      }
    } else if (fin !== null && inicio === null) {
      if (hoy <= fin) {
        return true;
      }
    } else {
      return true;
    }
  }

  verificarFechayHorario(banner): boolean {
    let fin, inicio, horaFin, horaInicio;
    const hoy = new Date();
    const hora = new Date().getTime();
    if (banner.fechaVencimiento !== null) {
      fin = new Date(banner.fechaVencimiento);
      horaFin = new Date(banner.fechaVencimiento).getTime();
    } else {
      fin = null;
    }
    if (banner.fechaLanzamiento !== null) {
      inicio = new Date(banner.fechaLanzamiento);
      horaInicio = new Date(banner.fechaLanzamiento).getTime();
    } else {
      inicio = null;
    }
    if (inicio !== null && fin !== null) {
      if (hoy >= inicio && hoy <= fin && hora >= horaInicio && hora <= horaFin) {
        return true;
      } else {
        return false;
      }
    } else if (inicio !== null && fin === null) {
      if (hoy >= inicio && hora >= horaInicio) {
        return true;
      }
    } else if (fin !== null && inicio === null) {
      if (hoy <= fin && hora <= horaFin) {
        return true;
      }
    } else {
      return true;
    }
  }

  public verificarNewImages(banner): boolean {
    return (
      banner.nombre_xxl != undefined &&
      banner.nombre_xl != undefined &&
      banner.nombre_lg != undefined &&
      banner.nombre_md != undefined &&
      banner.nombre_sm != undefined
    );
  }
}
